import { siteInfo, navLinks, footerData } from '@/mocks/home';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="pt-14 md:pt-20 pb-8 px-4 md:px-6 bg-background-950">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 pb-10 border-b border-background-700/30">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-lg font-bold text-foreground-200">{siteInfo.name}</span>
            </div>
            <p className="text-xs text-foreground-600 leading-relaxed">{footerData.description}</p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-300 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-300 mb-4">影视分类</h3>
            <div className="flex flex-col gap-2">
              {['国产剧', '韩剧', '美剧', '港剧', '日剧', '综艺', '动漫', '纪录片'].map((cat) => (
                <span key={cat} className="text-xs text-foreground-600 whitespace-nowrap cursor-pointer hover:text-foreground-400 transition-colors">
                  {cat}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-300 mb-4">合作伙伴</h3>
            <p className="text-xs text-foreground-600">优质内容合作，共创影视生态</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6">
          <p className="text-xs text-foreground-700">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-700 cursor-pointer hover:text-foreground-500 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-foreground-700 cursor-pointer hover:text-foreground-500 transition-colors whitespace-nowrap">服务条款</span>
            <span className="text-xs text-foreground-700 cursor-pointer hover:text-foreground-500 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}